export const branchList = [
  {
    value: "1",
    title: "Hospital",
  },
  {
    value: "2",
    title: "General Medical Complex",
  },
  {
    value: "3",
    title: "Specialized Medical Complex",
  },
  {
    value: "4",
    title: "Diagnostic Center",
  },
  {
    value: "5",
    title: "Clinic",
  },
  {
    value: "6",
    title: "Pharmacy",
  },
  {
    value: "7",
    title: "Laboratory",
  },
  {
    value: "8",
    title: "Physiotherapy Center",
  },
  {
    value: "9",
    title: "Radiotherapy Center",
  },
  {
    value: "other",
    title: "other",
  },
];

export const cityList = [
  {
    value: 1,
    title: "Al Artaweeiyah",
  },
  {
    value: 2,
    title: "Al Bahah",
  },
  {
    value: 3,
    title: "Al Jafer",
  },
  {
    value: 4,
    title: "Al Jawf",
  },
  {
    value: 5,
    title: "Al Kharj",
  },
  {
    value: 6,
    title: "Al Lith",
  },
  {
    value: 7,
    title: "Al Majmaah",
  },
  {
    value: 8,
    title: "Al Mawain",
  },
  {
    value: 9,
    title: "Al Mikhwah",
  },
  {
    value: 10,
    title: "Al Qunfudhah",
  },
  {
    value: 11,
    title: "Al Wajh",
  },
  {
    value: 12,
    title: "Al-Abwa",
  },
  {
    value: 13,
    title: "Al-Gwei'iyyah",
  },
  {
    value: 14,
    title: "Al-Hareeq",
  },
  {
    value: 15,
    title: "Al-Khutt",
  },
  {
    value: 16,
    title: "Al-Mubarraz",
  },
  {
    value: 17,
    title: "Al-Namas",
  },
  {
    value: 18,
    title: "Al-Omran",
  },
  {
    value: 19,
    title: "Al-Oyoon",
  },
  {
    value: 20,
    title: "Al-Ula",
  },
  {
    value: 21,
    title: "Ar Rass",
  },
  {
    value: 22,
    title: "As Sulayyil",
  },
  {
    value: 23,
    title: "Az Zaimah",
  },
  {
    value: 24,
    title: "Badr",
  },
  {
    value: 25,
    title: "Baljurashi",
  },
  {
    value: 26,
    title: "Bareg",
  },
  {
    value: 27,
    title: "Bisha",
  },
  {
    value: 28,
    title: "Buq a",
  },
  {
    value: 29,
    title: "Buraydah",
  },
  {
    value: 30,
    title: "Dahaban",
  },
  {
    value: 31,
    title: "Dammam",
  },
  {
    value: 32,
    title: "Dawadmi",
  },
  {
    value: 33,
    title: "Dhahran",
  },
  {
    value: 34,
    title: "Dhurma",
  },
  {
    value: 35,
    title: "Diriyah",
  },
  {
    value: 36,
    title: "Duba",
  },
  {
    value: 37,
    title: "Dumat Al-Jandal",
  },
  {
    value: 38,
    title: "Farasan city",
  },
  {
    value: 39,
    title: "Gatgat",
  },
  {
    value: 40,
    title: "Gerrha",
  },
  {
    value: 41,
    title: "Gurayat",
  },
  {
    value: 42,
    title: "Habala",
  },
  {
    value: 43,
    title: "Hafr Al-Batin",
  },
  {
    value: 44,
    title: "Hail",
  },
  {
    value: 45,
    title: "Hajrah",
  },
  {
    value: 46,
    title: "Haql",
  },
  {
    value: 47,
    title: "Harmah",
  },
  {
    value: 48,
    title: "Hautat Sudair",
  },
  {
    value: 49,
    title: "Hofuf",
  },
  {
    value: 50,
    title: "Hotat Bani Tamim",
  },
  {
    value: 51,
    title: "Huraymila",
  },
  {
    value: 52,
    title: "Jabal Umm al Ru'us",
  },
  {
    value: 53,
    title: "Jalajil",
  },
  {
    value: 54,
    title: "Jeddah",
  },
  {
    value: 55,
    title: "Jizan",
  },
  {
    value: 56,
    title: "Jizan Economic City",
  },
  {
    value: 57,
    title: "Jubail",
  },
  {
    value: 58,
    title: "Khafji",
  },
  {
    value: 59,
    title: "Khamis Mushayt",
  },
  {
    value: 60,
    title: "Khaybar",
  },
  {
    value: 61,
    title: "Khobar",
  },
  {
    value: 62,
    title: "King Abdullah Economic City",
  },
  {
    value: 63,
    title: "Knowledge Economic City , Medina",
  },
  {
    value: 64,
    title: "Layla",
  },
  {
    value: 65,
    title: "Lihyan",
  },
  {
    value: 66,
    title: "Mastoorah",
  },
  {
    value: 67,
    title: "Mecca",
  },
  {
    value: 68,
    title: "Medina",
  },
  {
    value: 69,
    title: "Muzahmiyya",
  },
  {
    value: 70,
    title: "Najran",
  },
  {
    value: 71,
    title: "Omloj",
  },
  {
    value: 72,
    title: "Qadeimah",
  },
  {
    value: 73,
    title: "Qaisumah",
  },
  {
    value: 74,
    title: "Qatif",
  },
  {
    value: 75,
    title: "Rabigh",
  },
  {
    value: 76,
    title: "Rafha",
  },
  {
    value: 77,
    title: "Ras Tanura",
  },
  {
    value: 78,
    title: "Riyadh",
  },
  {
    value: 79,
    title: "Riyadh Al-Khabra",
  },
  {
    value: 80,
    title: "Rumailah",
  },
  {
    value: 81,
    title: "Sabt Al Alaya",
  },
  {
    value: 82,
    title: "Safwa city",
  },
  {
    value: 83,
    title: "Saihat",
  },
  {
    value: 84,
    title: "Sakakah",
  },
  {
    value: 85,
    title: "Shaqraa",
  },
  {
    value: 86,
    title: "Sharurah",
  },
  {
    value: 87,
    title: "Shaybah",
  },
  {
    value: 88,
    title: "Tabarjal",
  },
  {
    value: 89,
    title: "Tabuk",
  },
  {
    value: 90,
    title: "Taif",
  },
  {
    value: 91,
    title: "Tanomah",
  },
  {
    value: 92,
    title: "Tarout",
  },
  {
    value: 93,
    title: "Tayma",
  },
  {
    value: 94,
    title: "Thadiq",
  },
  {
    value: 95,
    title: "Thuqbah",
  },
  {
    value: 96,
    title: "Thuwal",
  },
  {
    value: 97,
    title: "Turaif",
  },
  {
    value: 98,
    title: "Udhailiyah",
  },
  {
    value: 99,
    title: "Um Al-Sahek",
  },
  {
    value: 100,
    title: "Unaizah",
  },
  {
    value: 101,
    title: "Uqair",
  },
  {
    value: 102,
    title: "Uyayna",
  },
  {
    value: 103,
    title: "Uyun AlJiwa",
  },
  {
    value: 104,
    title: "Wadi Al-Dawasir",
  },
  {
    value: 105,
    title: "Yanbu",
  },
  {
    value: 106,
    title: "Zulfi",
  },
];
